import React from 'react';
import Testimonial, {TestimonialData} from './testimonial';
import {useDispatch} from 'react-redux';
import {toggleCollegeTestimonialHelpfulness} from 'shared/college-profile/actions/testimonials';
import Card from 'src/components/cards/card';
import CollapsibleTeaserSection from 'shared/components/collapsible-teaser-section';

interface Props {
  testimonials: TestimonialData[];
  nonStudent?: boolean;
}

const AboutTestimonials = ({testimonials, nonStudent}: Props) => {
  const dispatch = useDispatch();

  const renderTestimonials = (items: TestimonialData[]) =>
    items.map((testimonial, index) => (
      <Testimonial
        key={`testimonial-${index}`}
        showHorizontalRule={index !== items.length - 1}
        testimonial={testimonial}
        toggleCollegeTestimonialHelpfulness={(id) =>
          dispatch(toggleCollegeTestimonialHelpfulness(id))
        }
        nonStudent={nonStudent}
      />
    ));

  const renderTestimonialsBySize = (items: TestimonialData[]) => {
    const renderedTestimonials = renderTestimonials(items);
    const subtitle = items.length > 1 ? `${items.length} testimonials` : '1 testimonial';
    return items.length > 2
      ? renderCollapsibleTestimonials(renderedTestimonials, subtitle)
      : renderShortTestimonials(renderedTestimonials, subtitle);
  };

  const renderShortTestimonials = (renderedTestimonials, subtitle) => (
    <div className="about-testimonials-container">
      <h2 className="about-testimonials-container-header">Student Testimonials</h2>
      <p className="about-testimonials-container-subtitle">{subtitle}</p>
      {renderedTestimonials}
    </div>
  );

  const renderCollapsibleTestimonials = (renderedTestimonials, subtitle) => (
    <CollapsibleTeaserSection
      title="Student Testimonials"
      subtitle={subtitle}
      trackIdentifier="college-listing-about-testimonials"
      className="college-profile-card-about-content teaser-testimonials-container"
    >
      <CollapsibleTeaserSection.Teaser>
        {renderedTestimonials.slice(0, 2)}
      </CollapsibleTeaserSection.Teaser>
      <CollapsibleTeaserSection.Body>{renderedTestimonials.slice(2)}</CollapsibleTeaserSection.Body>
    </CollapsibleTeaserSection>
  );

  const renderedTestimonialsContainer = renderTestimonialsBySize(testimonials);
  return <Card className="zero-bottom-padding">{renderedTestimonialsContainer}</Card>;
};

export default AboutTestimonials;
